<div>
    <div class="search-box">
        <div class="container-box">
            <div class="row search-header">
                <div class="col-auto">
                    <mat-icon svgIcon="library_add_check"></mat-icon>
                </div>
                <span class="col-auto">{{'dpo.i18n.subscription.information.header' | translate}}</span>
            </div>
        </div>
        <div class="container-box">
            <form>
                <div class="container">
                    <div class="row criteria-box">
                        <div class="col-4 col-sm-6 col-md-4 col-lg-3">
                            <strong>{{'dpo.i18n.label.rrdi' | translate}}</strong>
                        </div>
                        <label class="col-auto col-sm-auto col-md-auto col-lg-auto"
                            name="rrdi">{{rrdiViewValue}}</label>
                    </div>
                    <div class="row criteria-box">
                        <div class="col-4 col-sm-6 col-md-4 col-lg-3">
                            <strong>{{'dpo.i18n.label.vin' | translate}}</strong>
                        </div>
                        <label class="col-auto col-sm-auto col-md-auto col-lg-auto" name="vin">{{vinViewValue}}</label>
                    </div>
                    <div class="row criteria-box">
                        <div class="col-4 col-sm-6 col-md-4 col-lg-3">
                            <strong>{{'dpo.i18n.label.warranty.date' | translate}}</strong>
                        </div>
                        <label class="col-auto col-sm-auto col-md-auto col-lg-auto"
                            name="warrantyEndDate">{{warrantyEndDateViewValue}}</label>
                    </div>
                    <div class="row criteria-box">
                        <div class="col-4 col-sm-6 col-md-4 col-lg-3">
                            <strong>{{'dpo.i18n.label.campaign.inprogress' | translate}}</strong>
                        </div>
                        <label class="col-auto col-sm-auto col-md-auto col-lg-auto"
                            name="campaign">{{campaignViewValue | translate}}</label>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="result-box">
        <div class="container-box">
            <div class="mat-elevation-z8">
                <table id="currentSubscriptionTable" mat-table [dataSource]="curentSubscriptionDataSource" matSort
                    #currentSubscriptionSort="matSort" aria-describedby="currentSubscriptionTable">

                    <!-- Prestation Column -->
                    <ng-container matColumnDef="prestation">
                        <th id="prestation" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.prestation' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.prestation}} </td>
                    </ng-container>

                    <!-- ECU Column -->
                    <ng-container matColumnDef="ecu">
                        <th id="ecu" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.ecu' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.ecu}} </td>
                    </ng-container>

                    <!-- Billable Column -->
                    <ng-container matColumnDef="billable">
                        <th id="billable" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.billable' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.billable}} </td>
                    </ng-container>

                    <!-- Subscription Date Column -->
                    <ng-container matColumnDef="subscriptionDate">
                        <th id="subscriptionDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.subscription.date' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionDate | date}} </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="subscriptionLabel">
                        <th id="subscriptionLabel" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.status' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionLabel}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="curentSubscriptionDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: curentSubscriptionDisplayedColumns;"></tr>
                </table>

                <mat-paginator #currentSubscriptionPaginator [pageSizeOptions]="[10, 20, 30, 40, 50]"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <div class="container-box">
            <div class="mat-elevation-z8">
                <table id="subscriptionAreaTable" mat-table [dataSource]="subscriptionAreaDataSource" matSort
                    #subscriptionAreaSort="matSort" aria-describedby="subscriptionAreaTable">

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th id="checkbox" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.action' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <input type="checkbox" [(ngModel)]="element.checkbox"
                                (change)="updateCheckboxCount(element.checkbox)"
                                *ngIf="element.subscriptionStatus !== 2"
                                [disabled]="element.subscriptionStatus === 3" />
                        </td>
                    </ng-container>

                    <!-- Prestation Column -->
                    <ng-container matColumnDef="prestation">
                        <th id="prestation" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.prestation' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.prestation | translate}} </td>
                    </ng-container>

                    <!-- Billable Column -->
                    <ng-container matColumnDef="billable">
                        <th id="billable" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.billable' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.billable | translate}} </td>
                    </ng-container>

                    <!-- Quantity Column -->
                    <ng-container matColumnDef="quantity">
                        <th id="quantity" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.quantity' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <input type="number" min="1" max="10" [(ngModel)]="element.quantity"
                                [disabled]="element.subscriptionStatus === 2 || element.subscriptionStatus === 3 || element.subscriptionStatus === 5"
                                pattern="/^[0-9]+$/"
                                (keyup)="validateQuantity($event.target.value) ? true : ($event.target.value = quantityValue)" />
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="subscriptionLabel">
                        <th id="subscriptionLabel" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.status' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionLabel | translate}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="subscriptionAreaDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: subscriptionAreaDisplayedColumns;"></tr>
                </table>

                <mat-paginator #subscriptionAreaPaginator [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>
            <div class="action-button">
                <button class="btn"
                    (click)="cancelSubscription()">{{'dpo.i18n.subscription.button.cancel' | translate}}</button>
                <button class="btn" (click)="checkCheckboxCount()"
                    [disabled]="!rrdiViewValue">{{'dpo.i18n.subscription.button.validate' | translate}}</button>
            </div>
        </div>
    </div>
    <!-- CAP-20457: Start --Instructions page added during translation change-->
    <div *ngIf="isARLanguage" dir="rtl" style="text-align: right">
        <p>{{'dpo.i18n.message.subscription.header.point' | translate}}</p>
        <ul>
            <li>{{'dpo.i18n.message.subscription.header.point1' | translate}}</li>
            <li>{{'dpo.i18n.message.subscription.header.point2' | translate}}</li>
        </ul>
    </div>
    <div *ngIf="isOtherLanguage" style="text-align: left">
        <p>{{'dpo.i18n.message.subscription.header.point' | translate}}</p>
        <ul>
            <li>{{'dpo.i18n.message.subscription.header.point1' | translate}}</li>
            <li>{{'dpo.i18n.message.subscription.header.point2' | translate}}</li>
        </ul>
    </div>
    <!-- CAP-20457: End -->
</div>

<!-- Form for callback -->
<div hidden>
    <form target="_blank" action="{{callbackUrl}}" id="callbackForm" method="post">
        <input id="jsonString" type="text" name="jsonString" value="{{jsonString}}" />
    </form>
</div>